import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import {
  ModalUniversoAuditavelImportaDadosComponent
} from "../modal-universo-auditavel-importa-dados/modal-universo-auditavel-importa-dados.component";
import { UniversoAuditavelService } from "../../../../services/universo-auditavel.service";
import { TipoUniversoService } from "../../../../services/tipo-universo.service";
import { IBaseModel } from "../../../../models/base.model";
import { ITipoUniversoModel } from "../../../../models/tipo-universo.model";
import { IRiscosChavesModel } from "../../../../models/riscos-chaves.model";
import { RiscosChavesServices } from "../../../../services/riscos-chaves.service";


@Component({
  selector: 'app-modal-riscos-chaves-nova-versao',
  templateUrl: 'modal-riscos-chaves-nova-versao.component.html',
  styleUrls: ['./modal-riscos-chaves-nova-versao.component.scss']
})
export class ModalRiscosChavesNovaVersaoComponent implements OnInit{
  private currentDialogRef: MatDialogRef<any>;
  public modelTipoUniverso: ITipoUniversoModel;
  public modelRiscosChaves: IRiscosChavesModel = {} as IRiscosChavesModel;
  constructor(
    private dialogRef: MatDialogRef<ModalRiscosChavesNovaVersaoComponent>,
    private matDialog: MatDialog,
    private riscosChavesService: RiscosChavesServices,
    private universoAuditavelService: UniversoAuditavelService,
    private tipoUniversoService: TipoUniversoService,
    @Inject(MAT_DIALOG_DATA) public data: any ,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public Sim() {
    this.dialogRef.close();
    this.inserirRiscosChaves();
  }
  public async inserirRiscosChaves(){
    try {

      let res: IBaseModel<any> = null;
      const result = await this.tipoUniversoService.obterPorId(this.data.tipoUniversoId);
      if(result.sucesso){
        this.modelTipoUniverso = result.dados;
        this.modelRiscosChaves.nomeTipoUniverso = this.modelTipoUniverso.nome;
        this.modelRiscosChaves.tipoUniversoAuditavelId = this.data.tipoUniversoId;
        this.modelRiscosChaves.unidadeGestoraId = this.data.unidadeGestoraId;
        this.modelRiscosChaves.criterioAvaliacaoId = this.data.criterioAvaliacaoId;
      }

      res = await this.riscosChavesService.inserir(this.modelRiscosChaves);
      if (res.sucesso) {
        this.router.navigate([`/riscos-chaves-form/${res.dados.id}`]);
      }

    }
    catch  {

    }
  }

  public Nao() {
    this.router.navigateByUrl(
      `/unidades-gestoras/${this.data.unidadeGestoraId}?aba=4`
    );
    this.dialogRef.close();
  }

  public cancelar() {
    this.dialogRef.close();
  }
}
